import { CDialog } from "shared";
import FunctionalityForm from "./FunctionalityForm";
import HealthReportForm from "./HealthReportForm";
import { EDITABLE_TYPES } from "./Activities";
import { Activity } from "routes/patient/queries/useSchedule";

interface Props {
  activity: Activity | null;
  onClose: () => void;
}

const EditActivity: React.VFC<Props> = ({ activity, onClose }) => {
  if (!activity) return null;
  let formEm = null;

  if (EDITABLE_TYPES.functionality.includes(activity.type))
    formEm = <FunctionalityForm activity={activity} onClose={onClose} />;
  else if (EDITABLE_TYPES.health.includes(activity.type))
    formEm = <HealthReportForm activity={activity} onClose={onClose} />;

  return (
    <CDialog maxWidth="xs" fullWidth open={!!formEm} onClose={onClose} aria-labelledby="edit-activity">
      {formEm}
    </CDialog>
  );
};

export default EditActivity;
